/** After Paddle's overlay closes on success: poll until the webhook has landed (spec §6.1 step 4). */
import { useEffect, useState } from "react";
import type { Api } from "../api/api";

export function ReturnScreen({
  api,
  onActive,
  pollMs = 1000,
  maxPolls = 20,
}: {
  api: Api;
  onActive: () => void;
  pollMs?: number;
  maxPolls?: number;
}) {
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (tries >= maxPolls) return;
    const t = setTimeout(
      async () => {
        const r = await api.billingMe();
        if (r.ok && r.data.active) return onActive();
        setTries((n) => n + 1);
      },
      tries === 0 ? 0 : pollMs,
    );
    return () => clearTimeout(t);
  }, [api, tries, pollMs, maxPolls, onActive]);
  if (tries >= maxPolls) {
    return (
      <main className="narrow">
        <h1>Almost there</h1>
        <p className="prose">
          Your payment went through, and the confirmation is on its way to us. Your account will
          unlock in a moment — carry on, and the header will update by itself.
        </p>
        <button type="button" className="button button--primary" onClick={onActive}>
          Continue
        </button>
      </main>
    );
  }
  return (
    <main className="narrow">
      <h1>Confirming your subscription…</h1>
      <p className="muted">This takes a second or two.</p>
    </main>
  );
}
